import { AnyObject } from '@triare/auth-redux';
import {
  DefaultFetchError,
  FetchCreate, FetchDelete,
  FetchGet,
  FetchGetId, FetchSuccess,
  FetchUpdate, PagingParams,
  useFetchCreate, useFetchDelete,
  useFetchGet,
  useFetchGetId,
  useFetchUpdate,
} from '../fetch';

export const settingsKeys = [
  'general',
  'faq',
  'referralTemplates',
] as const; // Converts the array into a tuple with literal types.

export type StaticSettingsKeys = typeof settingsKeys[number];

export interface SettingsGetParams extends PagingParams {
  orderByColumn?: 'key';
}

export interface SettingsItemProps<D = AnyObject> {
  key: StaticSettingsKeys;
  value: D;
  expiration?: string | null; // Date
}

export const useSettingsAllGet = <D = SettingsItemProps<AnyObject>>(
): FetchGet<Array<SettingsItemProps<D>>, SettingsGetParams> => useFetchGet(
    'settings',
    { autoStart: false, startStateLoading: false },
  );

export const useSettingsItemGetByKey = <D = SettingsItemProps<AnyObject>>(
  key?: string,
): FetchGetId<
  SettingsItemProps<D>,
  DefaultFetchError,
  unknown
  // D
> => useFetchGetId(
    'settings',
    key, // id
    {
      autoStart: !!key,
      // decorateData,
    },
  );

export const useSettingsItemCreate = <D = AnyObject>(): FetchCreate<
  FetchSuccess, DefaultFetchError, SettingsItemProps<D>> => (
    useFetchCreate('settings')
  );

export const useSettingsItemUpdate = <D = AnyObject>(id?: string): FetchUpdate<
  FetchSuccess, DefaultFetchError, Array<SettingsItemProps<D>>> => (
    useFetchUpdate('settings', id)
  );

export const useSettingsItemDelete = (id?: string): FetchDelete<
  FetchSuccess, DefaultFetchError> => (
  useFetchDelete('settings', id)
);

export const useTemporaryMeterReadingsExportCSV = (): FetchGetId<string, DefaultFetchError> => (
  useFetchGetId('temporary-meter-readings/export', '', { autoStart: false }, 'text')
);
